// PLUGINS IMPORTS //
import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import styled from 'styled-components/macro'

// COMPONENTS IMPORTS //
import MenuButton from './MenuButton/MenuButton'

import SideNavigation, {
  NavigationItemType,
} from '../SideNavigation/SideNavigation'
import { memoComparison } from 'Content/Shared/Helpers/Functions/Functions'

// EXTRA IMPORTS //
import HomeImage from 'Assets/Images/Icons/home.svg'
import AccountImage from 'Assets/Images/Icons/account.svg'
import ContactsImage from 'Assets/Images/Icons/contacts.svg'
import PortfolioImage from 'Assets/Images/Icons/portfolio.svg'

/////////////////////////////////////////////////////////////////////////////

type PropsType = {}

const Navbar: React.FC<PropsType> = () => {
  const [isParams, setIsParams] = useState<boolean>()
  const location = useLocation()

  useEffect(() => {
    setIsParams(location.pathname !== '/')
  }, [location])

  const homeLinks: Array<NavigationItemType> = [
    { title: 'HOME', icon: HomeImage, dest: '/' },
    { title: 'ABOUT ME', icon: AccountImage, dest: '/me' },
    { title: 'BLOG', icon: PortfolioImage, dest: '/blog' },
    { title: 'CONTACTS', icon: ContactsImage, dest: '/contacts' },
  ]

  const pagesLinks: Array<NavigationItemType> = [
    { title: 'PORTFOLIO', icon: PortfolioImage, dest: '/portfolio' },
  ]

  return (
    <>
      <Wrapper>
        <ContentWrapper>
          <MenuWrapper>
            {homeLinks.map((item, index) => (
              <MenuButton
                title={item.title}
                icon={item.icon}
                linkDest={item.dest}
              />
            ))}
          </MenuWrapper>
          <MenuWrapper>
            {pagesLinks.map((item, index) => (
              <MenuButton
                title={item.title}
                icon={item.icon}
                linkDest={item.dest}
              />
            ))}
          </MenuWrapper>
        </ContentWrapper>
      </Wrapper>
      <SideNavigation links={[...homeLinks, ...pagesLinks]} />
    </>
  )
}

/////////////////////////////////////////////////////////////////////////////

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

const ContentWrapper = styled.div`
  position: absolute;
  top: 40px;
  justify-content: space-between;
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 90%;

  @media (max-width: 768px) {
    top: 30px;
    width: 100%;
  }
  @media (max-width: 450px) {
    top: 20px;
    padding: 0 20px;
    width: 100%;
  }
`

const MenuWrapper = styled.div`
  display: flex;
  flex-direction: row;
`

export default React.memo(Navbar, memoComparison)
